import React, { useState, useEffect } from 'react'
import Copy from '../../cpn/Copy';
import classes from './invoice.module.css';        
import { Table } from 'antd';
import InvoiceCheck from './InvoiceCheck';
import StateTag from '../../cpn/StateTag';
import ReportCheck from '../../document/report/ReportCheck';
function InvoiceListNeedRead(props) {   
    const [list, setList] = useState([]);
    useEffect(() => {
        if (props.invoiceSpList) {
            const arr = props.invoiceSpList.filter((item) => (item.kpsq_sp_state === '2' || item.kpsq_sp_state === '3') && item.kpsq_sp_jd_name === '抄送');
            // 把未读的放前面
            // 假设"未读"定义为jk_sp_state === '2'
            const unread = arr.filter(item => item.kpsq_sp_state === '2');
            const read = arr.filter(item => item.kpsq_sp_state === '3');
            read.sort((a, b) => new Date(b.kpsq_sp_state_time) - new Date(a.kpsq_sp_state_time));
            const sortedArr = [...unread, ...read];
            setList(sortedArr);
        }
    }, [props.invoiceSpList]);

    const columns = [
        {
            title: '开票客户  ',
            dataIndex: 'kpsq_kh_name',
            key: 'kpsq_kh_name',
            width: "20%",
            render: (_, record) =>  <InvoiceCheck
                                        type='button'
                                        kpsq_id={record.kpsq_sp_kpsq_id} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        kpsq_bzd_id={record.kpsq_bzd_id}
                                        kpsq_price={record.kpsq_price}
                                        kpsq_content={record.kpsq_content}
                                        kpsq_date={record.kpsq_date}
                                        kpsq_date_end={record.kpsq_date_end}
                                        kpsq_bzd_name={record.kpsq_bzd_name}
                                        kpsq_bzd_danhao={record.kpsq_bzd_danhao}
                                        kpsq_type_id={record.kpsq_type_id}
                                        kpsq_type_name={record.kpsq_type_name}
                                        kpsq_kh_id={record.kpsq_kh_id}
                                        kpsq_kh_name={record.kpsq_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        kpsq_num={record.kpsq_num}
                                        kpsq_amount={record.kpsq_amount}
                                        kpsq_state={record.kpsq_state}
                                        kpsq_bm_id={record.kpsq_bm_id}
                                        kpsq_bm_name={record.kpsq_bm_name}
                                        kpsq_khyhzh_id={record.kpsq_khyhzh_id}
                                        kpsq_khyhzh_name={record.kpsq_khyhzh_name}
                                        kpsq_image_name={record.kpsq_image_name}
                                        kpsq_image_file={record.kpsq_image_file}
                                        kpsq_ctime={record.kpsq_ctime}
                                        kpsq_sp_id={record.kpsq_sp_id}
                                        kpsq_sp_yh_id={record.kpsq_sp_yh_id}
                                        kpsq_sp_state={record.kpsq_sp_state}
                                        kpsq_sp_kpsq_kh_name={record.kpsq_sp_kpsq_kh_name}
                                        kpsq_sp_jd_name={record.kpsq_sp_jd_name}
                                    />
        },
        {
            key: 'kpsq_sp_kpsq_amount',
            dataIndex: 'kpsq_sp_kpsq_amount',
            title: "开票金额",
            width: "6%",            
            render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },      
        {
            key: 'kpsq_sp_kpsq_name',
            dataIndex: 'kpsq_sp_kpsq_name',
            title: "开票项目",
            width: "8%",
            render: (text, record) => <Copy title={record.kpsq_sp_kpsq_name}/>
        },
        {
            key: 'kpsq_sp_dsbzd_name',
            dataIndex: 'kpsq_sp_dsbzd_name',
            title: "团队名称",
            width: "8%",
            render: (text, record) => <ReportCheck dsbzd_name={record.kpsq_sp_dsbzd_name} dsbzd_id={record.kpsq_sp_dsbzd_id} dsbzd_danhao={record.kpsq_sp_dsbzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
        },
        {
            key: 'kpsq_sp_uname',
            dataIndex: 'kpsq_sp_uname',
            title: "阅读记录",
            width: "8%",
            render: (text, record) => <>{record.kpsq_sp_uname} {record.kpsq_sp_ctime}</>,
        },
        {
            key: 'kpsq_sp_state',
            dataIndex: 'kpsq_sp_state',
            title: "状态",
            width: "5%",            
            render: (text) => <StateTag state={text} /> 
        },
        {
            key: 'kpsq_sp_kpsq_id',
            dataIndex: 'kpsq_sp_kpsq_id',
            title: "编号",
            width: "5%",       
        }
      
    ]
    return (
        <>
            <Table 
                className={classes.orangeHeader}
                size='small'
                bordered
                dataSource={list} 
                columns={columns} 
                rowKey='kpsq_sp_id'
                locale={{
                    emptyText: '暂无开票申请' // This will display text when the table is empty
                }}
                pagination={{
                    pageSize: 50,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        console.log(page, pageSize);
                    }
                }}
            />

        </>
    )
}

export default InvoiceListNeedRead